import { Search } from "lucide-react";

import { Button } from "@/components/ui/button";

export function SpotlightSearchBar() {
  return (
    <Button
      type="button"
      variant="outline"
      onClick={() =>
        window.dispatchEvent(new Event("signals:open-command-palette"))
      }
      className="h-8 w-full max-w-xl justify-start gap-2 border-border/80 bg-bg/60 px-3 text-muted-fg hover:bg-muted/40 hover:text-fg"
      aria-label="Search tools, chat rooms, and pages"
    >
      <Search className="size-4" aria-hidden />
      <span className="min-w-0 flex-1 truncate text-left text-sm">
        Search tools, chat rooms, pages...
      </span>
      <span className="hidden items-center gap-1 text-[10px] text-muted-fg sm:flex">
        <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono">
          Cmd K
        </kbd>
        <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono">
          /
        </kbd>
      </span>
    </Button>
  );
}
